import { HeaderView as Header} from './Header';
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router-dom";
import { actionSetListNotification, actionSetTranslate, actionSetUpdateTranslate } from '@/redux/actions';

// const mapStateToProps = (state) => ({...state})

const mapStateToProps = ({ NotificationReducer, TranslateReducer }) => ({
   $store: {
      NotificationReducer,
      TranslateReducer
   },
});
const mapDispatchToProps = (dispatch) => ({
   $action: bindActionCreators(
      {
        actionSetListNotification: actionSetListNotification,
        actionSetTranslate: actionSetTranslate,
        actionSetUpdateTranslate: actionSetUpdateTranslate,
      },
      dispatch
   ),
});


export const HeaderView: any = compose(
   withRouter,
   connect(mapStateToProps, mapDispatchToProps)
)(Header);
